import { FC, useState } from 'react'
import { useForm } from 'react-hook-form'

import { Form } from 'components/forms'
import DateSelect from 'components/date-select'
import { track } from 'lib/analytics'
import { NextButton } from '../../../OnboardingButtons/OnboardingButtons'
import { Checkbox } from 'components/forms'

interface ArrivalDateFormProps {
  initialValues: {
    arrivalDate: string
    isHavingMultipleBabies: boolean
  }
  onSaveArrivalDate: (data: {
    arrivalDate: string | null
    isHavingMultipleBabies: boolean
  }) => void
}

interface ArrivalDateFormFields {
  arrivalDate: string
  isHavingMultipleBabies: boolean
}

const ArrivalDateForm: FC<ArrivalDateFormProps> = ({
  initialValues,
  onSaveArrivalDate,
}) => {
  const { register, handleSubmit } = useForm<ArrivalDateFormFields>({
    defaultValues: initialValues,
  })
  const [arrivalDate, setArrivalDate] = useState(initialValues.arrivalDate)
  const [submitting, setSubmitting] = useState(false)

  const clearIfNotValidDate = (arrivalDate: string) =>
    arrivalDate && arrivalDate.match(/\d{4}-\d{2}-\d{2}/) ? arrivalDate : null

  const onSubmit = (data: ArrivalDateFormFields) => {
    setSubmitting(true)
    const date = clearIfNotValidDate(arrivalDate)

    track.onboardingQuestionAnswered({
      eventLocation: track.EventLocation.ONBOARDING_MINUS_ARRIVAL_DATE,
      answer: date || '',
    })

    onSaveArrivalDate({
      arrivalDate: date,
      isHavingMultipleBabies: data.isHavingMultipleBabies,
    })
    setSubmitting(false)
  }

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <DateSelect
        onChange={setArrivalDate}
        name="arrivalDate"
        label="Arrival Date (Optional)"
        groupClassName="mbm"
        value={arrivalDate}
      />

      <div style={{ marginTop: -10 }} className="mbxl">
        <Checkbox
          inputRef={register()}
          name="isHavingMultipleBabies"
          label="Umm, more than one is on the way!"
        />
      </div>

      <NextButton submitting={submitting} type="submit" />
    </Form>
  )
}

export default ArrivalDateForm
